module.exports = __webpack_public_path__ + "static/vegan-cola_logo_old-eea691c0b8e1077a0c512cedd4fa8a0b.svg";